export default __webpack_public_path__ + "9e2ac64.png";